<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login" @keydown.enter="handleSubmit">
    <div class="login-con">
      <Card title="后台管理系统">
        <div class="form-con">
          <Form ref="loginForm" :model="form" :rules="rules">
            <FormItem prop="username">
              <Input v-model="form.username" placeholder="请输入用户名">
              <span slot="prepend">
                <Icon :size="16" type="ios-person"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" v-model="form.password" placeholder="请输入密码">
              <span slot="prepend">
                <Icon :size="14" type="md-lock"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem >
              <img :src="url"  @click="changeLoginImage()" width="200px" height="50px" />
              <Input  v-model="form.googlepass" placeholder="请输入验证码" >
              <span slot="prepend">
                <Icon :size="14" type="ios-closed-captioning"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem style="margin-bottom: 15px;">
              <Button @click="handleSubmit" type="primary" long>登录</Button>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import {
  baseUrl
} from '@/libs/api.request'
import { mapActions } from 'vuex'
import { loginByQQ, wx, getQQCode, getQr, checkWxLogin, getWxCode } from '@/api/third-login'
import qq_login from '@/assets/images/qq-login.png'
import wx_login from '@/assets/images/wx-login.png'
import { filterAsyncRouter } from '@/libs/router-utils'

export default {
  data () {
    return {
      qq_login,
      wx_login,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      wxQrModel: false,
      wxQrUrl: '',
      loading: false,
      baseUrl:baseUrl+"Login/image?",
      url:baseUrl+"Login/image?"
    }
  },
  created () {
    let p = this.$route.params.loginType
    let q = this.$route.query
    if (p) {
      this.$Spin.show()
      let vm = this
      switch (p) {
        case 'qq':
          loginByQQ(q).then(response => {
            vm.$Spin.hide()
            vm.$store.commit('setUserInfo', response.data.data)
            vm.$store.commit('setToken', response.data.data.apiAuth)
            vm.$store.commit('updateMenuList', filterAsyncRouter(response.data.data.menu))
            sessionStorage.setItem('dynamicRouter', JSON.stringify(response.data.data.menu))
            sessionStorage.setItem('ApiAdmin_AppInfo', '管理员')
            vm.$router.push({
              name: 'home'
            })
          })
          break
        case 'wx':
          wx(q).then(response => {
            vm.$Spin.hide()
            vm.$store.commit('setUserInfo', response.data.data)
            vm.$store.commit('setToken', response.data.data.apiAuth)
            vm.$store.commit('updateMenuList', filterAsyncRouter(response.data.data.menu))
            sessionStorage.setItem('dynamicRouter', JSON.stringify(response.data.data.menu))
            sessionStorage.setItem('ApiAdmin_AppInfo', '管理员')
            vm.$router.push({
              name: 'home'
            })
          })
          break
        default :
          this.$Spin.hide()
          break
      }
    }
  },
  methods: {
    ...mapActions([
      'handleLogin'
    ]),
    changeLoginImage(){
      this.url=this.baseUrl+Math.random()*1000;
    },
    handleSubmit () {
      let vm = this
      let username = vm.form.username
      let password = vm.form.password
      let googlepass = vm.form.googlepass

      // 验证表单
      vm.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 检查验证码是否输入
          if (!googlepass || googlepass.trim() === '') {
            vm.$Message.error('请输入验证码')
            return
          }
          
          vm.loading = true
          vm.handleLogin({ username, password, googlepass }).then(() => {
            sessionStorage.setItem('ApiAdmin_AppInfo', '管理员')
            vm.$Message.success('登录成功')
            vm.$router.push({
              name: 'home'
            })
            vm.loading = false
          }).catch((err) => {
            vm.loading = false
            // 显示错误信息
            const errorMsg = (err && err.response && err.response.data && err.response.data.msg) || (err && err.message) || '登录失败，请检查用户名、密码和验证码'
            vm.$Message.error(errorMsg)
            // 刷新验证码
            vm.changeLoginImage()
            // 清空验证码输入
            vm.form.googlepass = ''
          })
        } else {
          vm.$Message.error('请填写完整的登录信息')
        }
      })
    },

  }
}
</script>
